<template>
  <el-form
    ref="form"
    :label-position="labelPosition"
    :label-width="labelWidthFilter"
    :model="model"
    :rules="rules"
    class="filter"
    @submit.native.prevent="doFilter"
  >
    <!-- {{matches}} -->
    <el-row
      :gutter="16"
      class="filter__container"
    >
      <!-- Date Range -->
      <el-col
        :lg="6"
        :md="16"
        :sm="24"
      >
        <el-form-item :prop="fields.dateRange.name">
          <div
            slot="label"
            class="form__item__label__slot"
          >
            <span v-text="fields.dateRange.label" />
            <el-button
              v-if="enabledResetDateField "
              type="text"
              @click="resetFieldFilter({ fieldKey: 'dateRange'})"
            >
              <app-i18n code="common.reset" />
            </el-button>
          </div>
          <!-- Watched -->
          <el-date-picker
            v-model="model[fields.dateRange.name]"
            type="daterange"
            :format="dateFormat"
          />
        </el-form-item>
      </el-col>

      <!-- Team to search -->
      <el-col
        :lg="6"
        :md="16"
        :sm="24"
      >
        <el-form-item :prop="fields.teamToFilter.name">
          <div
            slot="label"
            class="form__item__label__slot"
          >
            <span v-text="fields.teamToFilter.label" />
            <el-button
              v-if="model.teamToFilter"
              type="text"
              @click="resetFieldFilter({ fieldKey: 'teamToFilter'})"
            >
              <app-i18n code="common.reset" />
            </el-button>
          </div>
          <app-autocomplete-one-input
            v-model="model[fields.teamToFilter.name]"
            prefix-icon="icon-teams"
            :placeholder="i18n('entities.team.label.one')"
            :fetch-fn="fields.teamToFilter.fetchFn"
            :manage="{
              subpropertyId,
              programId,
              subprogramId,
              type: 'subprogram'
            }"
          />
        </el-form-item>
      </el-col>

      <!-- Status -->
      <el-col
        :lg="6"
        :md="16"
        :sm="24"
      >
        <el-form-item :prop="fields.status.name">
          <div
            slot="label"
            class="form__item__label__slot"
          >
            <span v-text="fields.status.label" />
            <el-button
              v-if="model.status"
              type="text"
              @click="resetFieldFilter({ fieldKey: 'status'})"
            >
              <app-i18n code="common.reset" />
            </el-button>
          </div>
          <el-select
            v-model="model[fields.status.name]"
            :placeholder="fields.status.label"
            filterable
            clearable
            @change="doFilter"
          >
            <i
              slot="prefix"
              class="icon-info"
            />
            <el-option
              v-for="option in gameStatus"
              :key="option.id"
              :label="option.label"
              :value="option.id"
            />
          </el-select>
        </el-form-item>
      </el-col>

      <!-- Type -->
      <el-col
        :lg="6"
        :md="16"
        :sm="24"
      >
        <el-form-item :prop="fields.type.name" v-if="model">
          <div
            slot="label"
            class="form__item__label__slot"
          >
            <span v-text="fields.type.label" />
            <el-button
              v-if="model.type"
              type="text"
              @click="resetFieldFilter({ fieldKey: 'type'})"
            >
              <app-i18n code="common.reset" />
            </el-button>
          </div>
          <el-select
            v-model="model[fields.type.name]"
            :placeholder="fields.type.label"
            filterable
            clearable
            @change="doFilter"
          >
            <i
              slot="prefix"
              class="icon-games"
            />
            <el-option
              v-for="option in gameType"
              :key="option.id"
              :label="option.label"
              :value="option.id"
            />
          </el-select>
        </el-form-item>
      </el-col>

      <!-- Rounds -->
      <el-col
        v-if="isRegularSeasonHasRounds && model[fields.type.name] !== 'playoffs'"
        :lg="5"
        :md="16"
        :sm="24"
      >
        <el-form-item
          :prop="fields.regularSeasonRound.name"
        >
          <div
            slot="label"
            class="form__item__label__slot"
          >
            <span v-text="fields.regularSeasonRound.label" />
            <el-button
              v-if="model[fields.regularSeasonRound.name]"
              type="text"
              @click="resetFieldFilter({ fieldKey: 'regularSeasonRound'})"
            >
              <app-i18n code="common.reset" />
            </el-button>
          </div>
          <el-select
            v-model="model[fields.regularSeasonRound.name]"
            :placeholder="i18n('common.select.placeholder')"
            clearable
            @change="doFilter"
          >
            <i
              slot="prefix"
              class="icon-games"
            />
            <el-option
              v-for="round in roundsOptions"
              :key="round.id"
              :label="round.order"
              :value="round.id"
            />
          </el-select>
        </el-form-item>
      </el-col>

      <!-- PLayoffs -->
      <el-col
      v-if="model[fields.type.name] !== 'groups'"
        :lg="5"
        :md="16"
        :sm="24"
      >
        <el-form-item
          :prop="fields.playoff.name"
        >
          <div
            slot="label"
            class="form__item__label__slot"
          >
            <span v-text="fields.playoff.label" />
            <el-button
              v-if="model[fields.playoff.name]"
              type="text"
              @click="resetFieldFilter({ fieldKey: 'playoff'})"
            >
              <app-i18n code="common.reset" />
            </el-button>
          </div>
          <el-select
            v-model="model[fields.playoff.name]"
            :placeholder="i18n('common.select.placeholder')"
            clearable
            @change="doFilter"
          >
            <i
              slot="prefix"
              class="icon-playoffs"
            />
            <el-option
              v-for="playoff in playoffOptions"
              :key="playoff.id"
              :label="playoff.label"
              :value="playoff.id"
            />
          </el-select>
        </el-form-item>
      </el-col>

      <!-- Filter buttons -->
      <el-col
        :lg="1"
        :md="16"
        :sm="24"
      >
        <div class="filter-buttons">
          <el-button
            :disabled="loading"
            icon="icon-undo"
            circle
            @click="doResetFilter"
          />
        </div>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { FilterSchema } from '@shared/form/filter-schema'
import { GameModel } from '@modules/game/game-model'
import { i18n, getLanguageCode } from '@shared/i18n'
import { debounce, get, uniqWith, isEqual, orderBy } from 'lodash'
import gameStatus from '@enums/gameStatus.json'
import playoffsNameI18n from '@enums/nbaPLayoffsNameI18n.json'

export default {
  name: 'AppSubprogramNbaScheduleFilter',

  props: {
    programId: {
      type: String,
      required: true,
    },
    subprogramId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      model: {},
      roundsUniq: [],
    }
  },

  computed: {
    ...mapGetters({
      labelPosition: 'layout/labelPosition',
      labelWidthFilter: 'layout/labelWidthFilter',
      loading: 'subprogram/nba/schedule/loading',
      filter: 'subprogram/nba/schedule/filter',
      currentManage: 'auth/manage/currentManage',
      dateFormat: 'auth/manage/dateFormat',
      timeFormat: 'auth/manage/timeFormat',
      subprogram: 'subprogram/nba/subprogram',
      matches: 'subprogram/nba/schedule/matches',
      roundsOptions: 'subprogram/nba/schedule/roundsOptions',
    }),

    subpropertyId() {
      return get(
        this,
        'currentManage.subproperty.id',
        null,
      )
    },
    enabledResetDateField() {
      const isArray = Array.isArray(this.model.dateRange)
      const size = isArray ? this.model.dateRange.length : 0

      return size > 1
    },

    rules() {
      const { filterSchema } = this
      return filterSchema.rules()
    },

    filterSchema() {
      const { fields } = this
      return new FilterSchema([
        fields.id,
        fields.status,
        fields.dateRange,
        fields.teamToFilter,
        fields.regularSeasonRound,
        fields.type,
        fields.playoff,
      ])
    },

    fields() {
      const { dateFormat, timeFormat } = this
      return new GameModel({ dateFormat, timeFormat }).fields()
    },

    isRegularSeasonHasRounds() {
      return get(this, 'subprogram.regularSeasonHasRounds', false)
    },

    gameStatus() {
      return this.fields.status.options.filter(({ id }) => gameStatus.some(status => status === id))
    },

    gameType() {
      return this.fields.type.options
    },

    rounds() {
      if (this.roundsUniq.length === 0) {
        const rounds = this.matches.map(match => get(match, 'regularSeasonRound', ''));
        [...this.roundsUniq] = uniqWith(rounds, isEqual)
      }
      const roundOrdered = orderBy(this.roundsUniq, 'order', 'asc')
      return roundOrdered
    },

    language() {
      return getLanguageCode()
    },

    playoffOptions() {
      return Object.keys(playoffsNameI18n).map((key) => ({
        id: key,
        label:  get(playoffsNameI18n[key], this.language, '-' )
      }))
    }
  },

  created() {
    if (this.$route.query.status) this.model.status = this.$route.query.status
    if (this.$route.query.type) this.model.type = this.$route.query.type
  },

  async mounted() {
    const { filterSchema } = this

    this.model = filterSchema.initialValues(
      this.filter,
      this.$route.query,
    )

    if (this.filter.teamToFilter) {
      this.model.teamToFilter.id = this.filter.teamToFilter
    }

    // this.doFetch({
    //   subpropertyId: this.subpropertyId,
    //   subprogramId: this.subprogramId
    // });
  },

  methods: {
    ...mapActions({
      doReset: 'subprogram/nba/schedule/doReset',
      doFetch: 'subprogram/nba/schedule/doFetch',
    }),

    async doResetFilter() {
      const { filterSchema } = this
      this.model = filterSchema.initialValues()
      this.$refs.form.clearValidate()

      return this.doReset({
        subpropertyId: this.subpropertyId,
        programId: this.programId,
        subprogramId: this.subprogramId,
      })
    },

    async resetFieldFilter({ fieldKey }) {
      if (this.model[`${fieldKey}`]) this.model[`${fieldKey}`] = null
      this.doFilter()
    },

    debounceInput: debounce(function () {
      this.doFilter()
    }, 500),

    async doFilter() {
      const { filterSchema } = this

      try {
        await this.$refs.form.validate()
        this.$refs.form.clearValidate()
      } catch (error) {
        return
      }

      const filter = filterSchema.cast(this.model)

      return this.doFetch({
        subpropertyId: this.subpropertyId,
        programId: this.programId,
        subprogramId: this.subprogramId,
        filter,
      })
    },

    i18n(code) {
      return i18n(code)
    },
  },

  watch: {
    'model.status': 'doFilter',
    'model.dateRange': 'doFilter',
    'model.teamToFilter.id': 'doFilter',
    'model.regularSeasonRound': 'doFilter',
  },
}
</script>

<style scoped>
</style>
